import React from "react";
import className from "classnames/bind";
import { useLanguageStore } from "../../stores/Language/useLanguageStore";
import useTranslations from "../../hooks/useTranslations";
import { translateProductName } from "../../utils/translateProductName";

/**
 * Component hiển thị tóm tắt đơn hàng
 * @param {Object} props
 * @param {Array} props.items - Danh sách sản phẩm
 * @param {Object} props.orderData - Dữ liệu đơn hàng
 * @param {Object} props.styles - SCSS styles object
 */
const OrderSummary = ({ items, orderData, styles }) => {
  const cx = className.bind(styles);
  const { formatPrice } = useLanguageStore();
  const translations = useTranslations();

  // Tính tổng tiền đơn hàng
  const calculateOrderTotal = () => {
    if (!items) return 0;
    return items.reduce((total, item) => total + (item.total || 0), 0);
  };

  const orderTotal = calculateOrderTotal();
  const currencySymbol = orderData?.paymentInfo?.currencySymbol || 'VND';

  return (
    <div className={cx("order-items")}>
      {items?.map((item, index) => (
        <div key={index} className={cx("item")}>
          <span className={cx("quantity")}>{item.quantity || 1} x</span>
          <span className={cx("name")}>{translateProductName(item.name)}</span>
          <span className={cx("price")}>
            Total:{" "}
            {formatPrice
              ? formatPrice(item.total || 0)
              : `${(item.total || 0).toLocaleString()} ${currencySymbol}`
            }
          </span>
        </div>
      ))}
      
      <div className={cx("total-amount")}>
        <strong>
          {translations?.PaymentSuccess?.total_order || "Total Order"}:{" "}
          {formatPrice
            ? formatPrice(orderTotal)
            : `${orderTotal.toLocaleString()} ${currencySymbol}`
          }
        </strong>
      </div>
    </div>
  );
};

export default OrderSummary;
